/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Col, Modal, Row, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import "../../../assets/style/table/deals.scss";
import { dealSelector } from "../../../services/selector/index.";
import {
  IconArrowDown,
  IconArrowTop,
  IconDetail,
  IconEdit,
  IconEye,
  IconLock,
  IconNext,
  IconPre,
  IconSave,
  IconSpin,
  IconXmark,
} from "../../../assets/icon";
import { useMemo } from "react";
import { setOpenPUDelete } from "../../../services/slice/PopUpSlice";
import TranslateText from "../TranslateText";
import { renameLimitDeal, renameTypeDeal } from "../../../utils/convertNumber";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { checkNumber, formatDate } from "../../../utils/functionCommon";
import {
  deleteItemPin,
  getDataArea,
  setValueDeleteConfig,
  updatePin,
} from "../../../services/slice/DealSlice";
import BaseButton from "../Button/BaseButton";

const TableArea = ({}) => {
  const { t } = useTranslation();
  const dealData = useSelector(dealSelector);
  const { dataAreaOne, refetchConfig } = dealData;
  const [dataUpdate, setDataUpDate] = useState([]);
  const dispatch = useDispatch();
  const [dataBackup, setDataBackup] = useState([...dataAreaOne]);
  useEffect(() => {
    dispatch(getDataArea());
    return;
  }, [dispatch]);
  useEffect(() => {
    if (refetchConfig) {
      dispatch(getDataArea());
    }
  }, [dispatch, refetchConfig]);
  useEffect(() => {
    if (dataAreaOne.length) {
      setDataBackup(dataAreaOne);
    }
  }, [dataAreaOne]);
  const handleSaveConfig = () => {
    dispatch(updatePin({ postPinList: [...dataUpdate] }));
  };
  const handleSortDown = (value) => {
    let newData = [...dataBackup];
    const itemIndex = newData.findIndex((item) => item.id === value.id);
    if (itemIndex !== -1 && itemIndex < newData.length - 1) {
      [newData[itemIndex], newData[itemIndex + 1]] = [
        newData[itemIndex + 1],
        newData[itemIndex],
      ];
      newData = newData.map((item, index) => {
        return {
          ...item,
          index: index + 1,
        };
      });
      setDataBackup(newData);
    }
  };
  const handleSortUp = (value) => {
    let newData = [...dataBackup];
    const itemIndex = newData.findIndex((item) => item.id === value.id);
    if (itemIndex > 0) {
      [newData[itemIndex], newData[itemIndex - 1]] = [
        newData[itemIndex - 1],
        newData[itemIndex],
      ];
      newData = newData.map((item, index) => {
        return {
          ...item,
          index: index + 1,
        };
      });
      setDataBackup(newData);
    }
  };
  const dataSource = useMemo(() => {
    let result = [];
    const listUpdate = [];
    result = dataBackup?.map((item, index) => {
      listUpdate.push({ id: item.id, index: index + 1 });
      return {
        ...item,
        key: item.id,
        status: renameTypeDeal(item.status),
        limit: renameLimitDeal(item.typePreferential),
        timeStart: formatDate(item.timeStart),
        timeEnd: formatDate(item.timeEnd),
        timeCreate: formatDate(item.timeCreate),
        STT: index + 1,
      };
    });
    setDataUpDate(listUpdate);
    return result;
  }, [dataBackup]);
  const columns = [
    {
      title: "Vị Trí",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 90,
    },
    {
      title: <TranslateText text="Tiêu đề" />,
      dataIndex: "title",
      key: "title",
      className: "title pointer",
      ellipsis: {
        showTitle: false,
      },
      render: (value) => (
        <Tooltip placement="topLeft" title={value}>
          {value}
        </Tooltip>
      ),
    },
    {
      title: <TranslateText text="Phạm vi" />,
      dataIndex: "range",
      key: "range",
      className: "limit centerCell",
    },

    {
      title: <TranslateText text="Trạng thái" />,
      key: "status",
      dataIndex: "status",
      // className: "evenSpace",
    },

    {
      title: <TranslateText text="Chức năng" />,
      key: "action",
      dataIndex: "action",
      className: "evenSpace centerCell",
      render: (text, record) => {
        return (
          <div
            className={dataBackup.length <= 1 ? "centerCell" : "evenSpace"}
            style={{ minWidth: "120px" }}
          >
            <span className="pointer iconTbl">
              {dataBackup.length <= 1 ? null : record.STT === 1 ? (
                <IconArrowDown onClick={() => handleSortDown(record)} />
              ) : record.STT === dataBackup.length ? (
                <IconArrowTop onClick={() => handleSortUp(record)} />
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <IconArrowTop
                    style={{ marginBottom: 5 }}
                    onClick={() => handleSortUp(record)}
                  />
                  <IconArrowDown onClick={() => handleSortDown(record)} />
                </div>
              )}
            </span>
            {/* {areaType === 2 ? (
              <span
                className="pointer iconTbl"
                onClick={() => {
                  dispatch(setValueDeleteConfig(record));
                  dispatch(deleteItemPin({ id: record.id }));
                }}
              >
                <Tooltip title="Xóa">
                  <IconEdit />
                </Tooltip>
              </span>
            ) : null} */}
            <span
              className="pointer iconTbl"
              onClick={() => {
                dispatch(setValueDeleteConfig(record));
                dispatch(deleteItemPin({ id: record.id }));
              }}
            >
              <Tooltip title="Xóa">
                <IconXmark />
              </Tooltip>
            </span>
          </div>
        );
      },
    },
  ];

  const tableLoading = {
    spinning: dataSource.length ? false : true, // isLoading là biến boolean để xác định xem có đang loading hay không
    indicator: <IconSpin className="iconSpin" />,
  };
  return (
    <>
      <Row>
        <Col style={{ flexGrow: 1, display: "flex", justifyContent: "end" }}>
          <BaseButton
            content={`Lưu`}
            width={120}
            typeBtn="btnOrange"
            icon={<IconSave />}
            handleClick={handleSaveConfig}
          />
        </Col>
      </Row>
      <Row style={{ width: "100%" }}>
        <Table
          loading={tableLoading}
          className="wrapperTblNewsPost"
          style={{ width: "100%", marginTop: "2.6rem" }}
          columns={columns}
          dataSource={dataSource}
          pagination={false}
        />
      </Row>
    </>
  );
};

export default TableArea;
